import { Grid, Stack } from "@mui/material";
import React from "react";

const BankDetails = () => {
  return (
    <Grid container spacing={1} className="w-full p-10 my-4">
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Bank Name
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Abu Dhabi bank
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Account Name
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Gokulnath
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Account Number
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        1234567890
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Account Branch
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Bussiness Bay Branch
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Currency
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        AED
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        IBAN
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        A47892798479179739
      </Grid>
    </Grid>
  );
};

export default BankDetails;
